import React, { ReactElement, useEffect, useState } from "react";
import { useHandleLogout } from "../hooks/useHandleLogout";
import { RoutePaths } from "../enumStrings";
import { Route, Routes } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import { ItemsPurchasableByChamberEnum } from "../graphql/types";
import useGetChamberFromUserIdInAuth from "../hooks/useGetChamberFromUserIdInAuth";
import Error404 from "./pages/ErrorPages/Error404";
import FullPageLoader from "./common/FullPageLoader";
import { useGetLoggedInAppInfo } from "../hooks/useGetLoggedInAppInfo";
import Layout from "./Layout/Layout";
import useScrollToTop from "../hooks/useScrollToTop";
import Loader from "./common/Loader";

const LogoutManual = (): ReactElement => {
  const handleLogout = useHandleLogout();

  useEffect(() => {
    handleLogout();
    // only run on page load that's why ignoring
    // eslint-disable-next-line
  }, []);

  return <></>;
};

const LogoutForDisabledAdmin = (): ReactElement => {
  const handleLogout = useHandleLogout();

  useEffect(() => {
    const runAtPageLoad = async () => {
      const authSession = await fetchAuthSession();

      if (
        authSession &&
        authSession.tokens &&
        authSession.tokens.accessToken &&
        authSession.tokens.accessToken.payload &&
        authSession.tokens.accessToken.payload["custom:isDisabled"] === "true"
      ) {
        handleLogout();
      }
    };

    runAtPageLoad();

    // only run on page load that's why ignoring
    // eslint-disable-next-line
  }, []);

  return <></>;
};

// const NavigateToSuspensionPageForSuspendedChamberMemberAdmin =
//   (): ReactElement => {
//     const location = useLocation();
//     useEffect(() => {
//       if (location.pathname !== RoutePaths.suspendedChamberMember) {
//         window.location.href = RoutePaths.suspendedChamberMember;
//       }
//     }, [location]);

//     return <></>;
//   };

type DataSyncMessageProps = {
  validationPercent?: number;
};

const DataSyncMessage = ({
  validationPercent = 93,
}: DataSyncMessageProps): ReactElement => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <div style={{ marginBottom: "24px" }}>
        <Loader />
      </div>
      <div
        style={{
          maxWidth: "680px",
          fontSize: "16px",
          lineHeight: 1.5,
          color: "#333",
        }}
      >
        <p style={{ marginBottom: "16px" }}>
          We released a large update on{" "}
          <strong>September 14 at 5:00 PM Eastern</strong> to finalize the
          verification of your data. Because of the size of this update, it may
          take <strong>1 week</strong> to reach the servers near you and for
          your computer to pick it up. When that happens, the loading screen
          will disappear and your dashboard will open automatically—no action
          needed. If you don’t see it yet, please check back soon. If you have
          any questions, please email{" "}
          <a
            href="mailto:support@chamberperksapp.com"
            style={{ color: "#E1A731", textDecoration: "none" }}
          >
            support@chamberperksapp.com
          </a>
          .
        </p>

        {/* <div style={{ textAlign: "left" }}>
          <div
            id="validation-progress-label"
            style={{ marginBottom: 8, fontWeight: 600 }}
          >
            Final validation progress
          </div>
          <div
            role="progressbar"
            aria-labelledby="validation-progress-label"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={validationPercent}
            aria-label="Final validation progress"
            tabIndex={0}
            style={{
              width: "100%",
              height: 12,
              backgroundColor: "#eee",
              borderRadius: 8,
              overflow: "hidden",
              boxShadow: "inset 0 1px 2px rgba(0,0,0,0.08)",
            }}
          >
            <div
              style={{
                width: `${validationPercent}%`,
                height: "100%",
                backgroundColor: "#E1A731",
                transition: "width 300ms ease",
              }}
            />
          </div>
          <div style={{ marginTop: 8, fontSize: 14, color: "#4a4a4a" }}>
            {validationPercent}% complete
          </div>
        </div> */}
      </div>
    </div>
  );
};

const LoggedInApp = (): ReactElement => {
  const handleLogout = useHandleLogout();
  const chamberInfo = useGetChamberFromUserIdInAuth();
  const [isLoading, setIsLoading] = useState(true);

  // Scroll to top when switching pages
  useScrollToTop();

  useEffect(() => {
    if (chamberInfo) {
      if (
        !(chamberInfo?.purchasedItems || []).includes(
          ItemsPurchasableByChamberEnum.ChamberMemberPro
        )
      ) {
        handleLogout();
      } else {
        setIsLoading(false);
      }
    }
  }, [chamberInfo, handleLogout]);

  const { userRoutesToShow } = useGetLoggedInAppInfo();

  // // Show data sync message unless chamber email is the excluded one
  // const shouldShowDataSyncMessage =
  //   chamberInfo?.supportContactEmail !== "subscriptions@chamberperksappp.com";

  return (
    <>
      {isLoading ? (
        <FullPageLoader />
      ) : (
        // : shouldShowDataSyncMessage ? (
        //   <DataSyncMessage />
        // )
        <Layout>
          <LogoutForDisabledAdmin />
          <Routes>
            <Route path={RoutePaths.logout} element={<LogoutManual />} />
            {userRoutesToShow}
            <Route path="*" element={<Error404 />} />
          </Routes>
        </Layout>
      )}
    </>
  );
};

export default LoggedInApp;
